import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/main'
import HelloWorld from '@/components/HelloWorld'



Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: 'main',
        component: main
    }, {
        path: '/detail',
        name: 'HelloWorld',
        component: HelloWorld
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js